import { render, staticRenderFns } from "./SurveillanceCaseDetail.vue?vue&type=template&id=592ba74d&scoped=true&"
import script from "./SurveillanceCaseDetail.vue?vue&type=script&lang=js&"
export * from "./SurveillanceCaseDetail.vue?vue&type=script&lang=js&"
import style0 from "./SurveillanceCaseDetail.vue?vue&type=style&index=0&id=592ba74d&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "592ba74d",
  null
  
)

export default component.exports